import { state, property } from 'lit/decorators.js';
import { ButtonBaseStateTrailingSlotIconController } from './button-base-state-trailing-slot-icon-controller.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const CrntButtonBaseMixin = (superClass) => {
  class CrntButtonBase extends superClass {
    constructor() {
      super(...arguments);
      /** Controller to handle the fixed trailing slot icon for processing and success states. */
      this._buttonStateTrailingSlotIconController = new ButtonBaseStateTrailingSlotIconController(this);
      this._hasLeading = false;
      this._hasTrailing = false;
      this.iconOnly = false;
      this.fullWidth = false;
      this.interactionState = "default";
      this.inverted = false;
      this.state = "enabled";
      this.variant = "primary";
    }
    static {
      /** ==================================================================================================================
      * @region Internal logic
      ================================================================================================================== */
      // static readonly styles = [trustedCSS(buttonBaseStyles)];
      this.tagName = "crnt-button-base";
    }
    get _isDisabled() {
      return ["disabled", "processing", "success"].includes(this.state);
    }
    _setHasIcons() {
      this._hasLeading = !!this.querySelector?.('[slot="leading"]');
      this._hasTrailing = !!this.querySelector?.('[slot="trailing"]') || !!this.querySelector?.('[slot="fixed-trailing"]');
    }
    /** ==================================================================================================================
    * @region Lifecycle events
    ================================================================================================================== */
    firstUpdated() {
      this._buttonStateTrailingSlotIconController.handleFixedTrailingSlotIcon(this.state);
      this._setHasIcons();
    }
    willUpdate(changedProperties) {
      if (changedProperties.has("state")) {
        this._buttonStateTrailingSlotIconController.handleFixedTrailingSlotIcon(this.state);
        this._setHasIcons();
      }
    }
  }
  __decorateClass([
    state()
  ], CrntButtonBase.prototype, "_hasLeading");
  __decorateClass([
    state()
  ], CrntButtonBase.prototype, "_hasTrailing");
  __decorateClass([
    property({ attribute: "icon-only", reflect: true, type: Boolean, useDefault: true })
  ], CrntButtonBase.prototype, "iconOnly");
  __decorateClass([
    property({ attribute: "full-width", reflect: true, type: Boolean })
  ], CrntButtonBase.prototype, "fullWidth");
  __decorateClass([
    property({ attribute: "interaction-state" })
  ], CrntButtonBase.prototype, "interactionState");
  __decorateClass([
    property({ reflect: true, type: Boolean })
  ], CrntButtonBase.prototype, "inverted");
  __decorateClass([
    property({ reflect: true })
  ], CrntButtonBase.prototype, "state");
  __decorateClass([
    property({ reflect: true })
  ], CrntButtonBase.prototype, "variant");
  return CrntButtonBase;
};

export { CrntButtonBaseMixin };
